import React from 'react';
import { ObvTileChart } from 'widgets/obvTile/components/chart/ObvTileChart';
import { ObvTileData } from 'widgets/obvTile/obvTileData';

interface ObvTileContentProps {
    symbol?: string;
    capsuleKey: string;
    data?: ObvTileData;
}

export function ObvTileContent(props: ObvTileContentProps) {
    const { data, capsuleKey } = props;

    if (!data) {
        return <div className="ObvTileContent">No data</div>;
    }

    return (
        <div className="ObvTileContent ">
            <ObvTileChart data={data} chartKey={capsuleKey} />
        </div>
    );
}
